export const FERTILIZER_BIN_ROUNDING_VALUE = 50;
export const NITROGEN_FERTILIZER_BIN_ROUNDING_VALUE = 5;
export const NUM_FERTILIZER_RATE_BINS = 7;

export const ADVANCED_SEED_BIN_ROUNDING_VALUE = 50;
export const SEED_BIN_ROUNDING_VALUE = 500;
export const NUM_SEED_RATE_BINS = 7;

export const MAXIMUM_AXIS_RANGE_INCREASE = 1.5;
